import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Container,
  TextField,
  Typography
} from '@mui/material';
import FormikForm from 'src/ui-component/FormikFormLibrary';
import toast from 'react-hot-toast';
import { Fields } from '../../../ui-component/FormikFormLibrary/FormikTypes';
import { httpRequest } from 'src/services/httpRequest';
import { handleError } from 'src/redux-store/slices/errorSlice';
import { useDispatch, useSelector } from 'react-redux';
import PdfGenerator from 'src/ui-component/PdfGenerator';
import FormHeaderGreeting from 'src/components/Greeting/FormHeaderGreeting';
import Breadcrumb from 'src/ui-component/Breadcrumb';
import LoadingOverlay from 'src/components/common/LoadingOverlay';
import { RootState } from 'src/redux-store/appStore';
import { useNavigate, useParams } from 'react-router-dom';
import CustomModal from 'src/ui-component/customModal/CustomModal';
import UploadDocs from '../../../ui-component/UploadDocs';
import { getFeesForCurrentPermit } from '../common/getFeesForCurrentPermit';
import {
  PaymentApplicationDetails,
  PaymentSummary
} from 'src/types/RoadPermit/roadPermit.type';

const NewApplication: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { townshipId, permit } = useParams();
  const userData = useSelector((store: RootState) => store.user.userDetails);
  const [loading, setLoading] = useState<boolean>(false);
  const [docsErrorMessege, setDocsErrorMessege] = useState<string>('');
  const [clonData, setclonData] = useState<Fields[]>([]);
  const [IsOpen, setIsOpen] = useState<boolean>(false);
  const [file, setFile] = useState<[]>([]);
  const [clickedOn, setClickedOn] = useState<string>('');
  const [feeDetails, setFeeDetails] = useState({
    applicationFee: 0,
    inspectionFee: 0
  });
  const [taxRate, setTaxRate] = useState<number>(0);

  // Dependency function for VehicleUsed field
  function handleDependency(val: string) {
    if (val === 'Yes') {
      setclonData([
        {
          initialValue: '',
          fieldName: 'VehicleYear',
          fieldLabel: 'Year of Vehicle',
          fieldType: 'number',
          required: true
        },
        {
          initialValue: '',
          fieldName: 'VehicleManufactured',
          fieldLabel: 'Make of Vehicle',
          fieldType: 'number',
          required: true
        },
        {
          initialValue: '',
          fieldName: 'VehicleModel',
          fieldLabel: 'Model of Vehicle',
          fieldType: 'text',
          required: true
        },
        {
          initialValue: '',
          fieldName: 'VehicleType',
          fieldLabel: 'Type of Vehicle',
          fieldType: 'text',
          required: true
        },
        {
          initialValue: '',
          fieldName: 'VehicleColor',
          fieldLabel: 'Color of Vehicle',
          fieldType: 'text',
          required: true
        },
        {
          initialValue: '',
          fieldName: 'VehicleLisensePlateNumber',
          fieldLabel: 'License Plate Number',
          fieldType: 'text',
          required: true
        }
      ]);
    } else {
      setclonData([]);
    }
  }

  // All fields for the form using Formik
  const allFields: Fields[] = [
    {
      initialValue: '',
      fieldName: 'ApplicantName',
      fieldLabel: 'Applicant Name',
      fieldType: 'text',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'ApplicantPhoneNo',
      fieldLabel: 'Applicant Phone Number',
      fieldType: 'mobile',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'ApplicantAddress',
      fieldLabel: 'Applicant Address',
      fieldType: 'note'
    },
    {
      initialValue: '',
      fieldName: 'CompanyAddress',
      fieldLabel: 'Company Address ',
      fieldType: 'note',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'CompanyName',
      fieldLabel: 'Company Name',
      fieldType: 'text',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'CompanyEmail',
      fieldLabel: 'Company E-mail',
      fieldType: 'email',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'CompanyPhoneNumber',
      fieldLabel: 'Company Phone Number',
      fieldType: 'mobile',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'ContactName',
      fieldLabel: 'Contact Name',
      fieldType: 'text',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'StateOfIncorporation',
      fieldLabel: 'State of Incorporation',
      fieldType: 'text',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'DateOfIncorporation',
      fieldLabel: 'Date of Incorporation',
      fieldType: 'date',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'AgentNameOfCorporation',
      fieldLabel: 'Name of Registered Agent of corporation',
      fieldType: 'text',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'Purpose',
      fieldLabel: 'Purpose',
      fieldType: 'note'
    },
    {
      initialValue: '',
      fieldName: 'ServiesTypesToSold',
      fieldLabel:
        'What are the types of goods, property or services to be sold ?',
      fieldType: 'note',
      required: true
    },
    {
      initialValue: '',
      fieldName: 'ProcessOfSoldAndDeliver',
      fieldLabel:
        'Describe the process in which goods are sold and delivered ? ',
      fieldType: 'note',
      required: true
    },
    {
      initialValue: 'No',
      fieldName: 'VehicleUsed',
      fieldLabel: 'Will a Vehicle be used ? ',
      fieldType: 'radio',
      required: true,
      options: [
        { label: 'Yes', value: 'Yes' },
        { label: 'No', value: 'No' }
      ],
      br: true,
      dependency: handleDependency,
      dependencyValue: 'Yes',
      dependencyFields: clonData
    }
  ];

  // Function to handle Proceed to Payment button
  const handleProceedToPay = async (data: any) => {
    // setLoading(true);
    if (!file.length) {
      setDocsErrorMessege('At least one document is required.');
      return;
    }

    data.ApplicationFee = feeDetails?.applicationFee;
    if (clickedOn === 'Save Draft' && data.VehicleUsed === 'Yes') {
      data.InspectionFee = feeDetails?.inspectionFee;
    }

    data.VehicleUsed = data.VehicleUsed === 'Yes' ? true : false;

    data.DocumentFileUpload = file;

    if (clonData.length > 0) {
      data.InspectionFee = Number(feeDetails?.inspectionFee);
    }
    const response = await httpRequest(
      'POST',
      `/solicitor_permit_application/insert`,
      data
    );
    if (response?.status === 'success') {
      toast.success('Application submitted successfully.');
      let paymentSummary: PaymentSummary = {
        fees: Object.fromEntries(
          Object.entries(feeDetails).filter(([, value]) => value > 0)
        ),
        ...(taxRate > 0 ? { taxRate } : {})
      };
      if (!data.VehicleUsed) {
        paymentSummary = {
          fees: {
            applicationFee: paymentSummary.fees.applicationFee
          },
          taxRate: paymentSummary.taxRate
        };
      }

      const paymentApplicationDetails: PaymentApplicationDetails = {
        applicationDetails: {
          userName: `${userData?.FirstName} ${userData?.LastName}`,
          applicationNumber: null,
          applicationId: response?.data?.ApplicationID,
          applicationStatus: 'Draft',
          statusPayload: 'In Review',
          permitPrefix: 'Solicitor'
        }
      };
      navigate(`/payment-methods`, {
        state: { paymentSummary, paymentApplicationDetails }
      });
    } else if (response?.type === 'NETWORK_ERROR') {
    } else {
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
  };

  // Function to insert application
  const handleInsertApplication = async (data: any, type = '') => {
    if (!file.length) {
      setDocsErrorMessege('At least one document is required.');
      return;
    }
    data.ApplicationFee = feeDetails?.applicationFee;
    if (clickedOn === 'Save Draft' && data.VehicleUsed === 'Yes') {
      data.InspectionFee = feeDetails?.inspectionFee;
    }

    data.VehicleUsed = data.VehicleUsed === 'Yes' ? true : false;
    if (clickedOn !== 'Update' && !type) {
      data.DocumentFileUpload = file;
    }
    setLoading(true);
    setLoading(false);

    const response = await httpRequest(
      'POST',
      `/solicitor_permit_application/insert`,
      data
    );
    if (response?.status === 'success') {
      if (type) {
        return true;
      }
      toast.success(`Application submitted successfully.`);
      if (clickedOn === 'Save Draft') {
        setLoading(false);
        navigate(`/${townshipId}/Clerk Department/${permit}/draft-application`);
      } else {
        navigate(`/${townshipId}/Clerk Department/${permit}/application-list`);
      }
    } else if (response?.type === 'NETWORK_ERROR') {
    } else {
      setLoading(false);
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
  };

  // Function to handle form submission
  const handleSubmit = async (data) => {
    if (clickedOn === 'Proceed to Payment') {
      handleProceedToPay(data);
    } else if (clickedOn === 'Save Draft') {
      handleInsertApplication(data);
    }
  };

  // Function to get application fee
  const handleGetApplicationFee = async () => {
    setLoading(true);
    const response = await httpRequest(
      'GET',
      `/configuration/fee_details?PermitID=${permit}`
    );
    if (response?.status === 'success') {
      const feeObject = getFeesForCurrentPermit(response.data);
      setTaxRate(feeObject?.CreditCardFee || 0);
      setFeeDetails({
        applicationFee: Number(feeObject?.ApplicationFee),
        inspectionFee: Number(feeObject?.InspectionFee)
      });
      setLoading(false);
    } else if (response?.type === 'NETWORK_ERROR') {
    } else {
      setLoading(false);
      toast.error(response?.message);
      dispatch(handleError(response?.message));
    }
  };

  useEffect(() => {
    if (permit) {
      handleGetApplicationFee();
    }
  }, []);

  return loading ? (
    <LoadingOverlay />
  ) : (
    <Container sx={{ mt: 2 }} className="main-table-container">
      <Breadcrumb
        PermitName={'Clerk Solicitor'}
        PageTitle={'New Application'}
      />

      <FormHeaderGreeting
        name={`${userData?.FirstName} ${userData?.LastName}`}
        applicationType={'new'}
      />

      <Card>
        <Box
          m={{ md: 3, xs: 1 }}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography variant="h4">New Application</Typography>

          <PdfGenerator PermitName={'Clerk Solicitor'} allFields={allFields} />
        </Box>

        <Box m={{ md: 3, xs: 1 }}>
          <FormikForm
            allFields={allFields}
            buttonPlacement={'right'}
            defaultEnabledButton={['Proceed to Payment', 'Approve', 'Update']}
            buttonTitle={['Cancel', 'Save Draft', 'Proceed to Payment']}
            setClickedOn={setClickedOn}
            clickProp
            content={
              <>
                <Box display={'flex'} gap={2}>
                  <TextField
                    id="outlined-basic"
                    disabled
                    sx={{ mt: 2 }}
                    value={`$ ${feeDetails?.applicationFee}.00`}
                    label="Application Fee"
                    variant="outlined"
                    InputLabelProps={{
                      className: 'weight-600'
                    }}
                  />

                  {clonData.length > 0 && (
                    <TextField
                      id="outlined-basic"
                      disabled
                      sx={{ mt: 2 }}
                      label="Additional Fee"
                      value={`$ ${feeDetails?.inspectionFee}.00`}
                      variant="outlined"
                      InputLabelProps={{
                        className: 'weight-600'
                      }}
                    />
                  )}
                </Box>

                <Button
                  sx={{ marginTop: 2 }}
                  variant="contained"
                  onClick={() => {
                    setIsOpen(true);
                    setDocsErrorMessege('');
                  }}
                >
                  Upload Documents
                </Button>
                <Typography sx={{ color: '#8B0000' }} m={1}>
                  {docsErrorMessege}
                </Typography>
              </>
            }
            formMethod={handleSubmit}
            heading={'Clerk Department'}
            handleOtherButton={() => {
              navigate(`/dashboard/${permit}`);
            }}
          />
        </Box>
      </Card>

      <CustomModal
        title={'Upload documents'}
        IsOpen={IsOpen}
        setIsOpen={setIsOpen}
        loading={loading}
        actionButtons={['Save']}
        content={
          <UploadDocs
            ApplicationID={''}
            file={file}
            setFile={setFile}
            setLoading={setLoading}
            reFetch={() => { }}
            permitName={'Solicitor'}
          />
        }
      />
    </Container>
  );
};

export default NewApplication;
